window.bootstrap = require("bootstrap");

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Safari fails to repaint the DataTables scroll body after a draw replaces the
// rows (it culls the overflow container's stale content until the user
// scrolls). Force a real repaint across two frames: a processed scroll-position
// change plus a layout invalidation — restoring both in the second frame keeps
// it invisible. A same-frame nudge gets coalesced away, so two frames matter.
$(document).on("draw.dt", function (e) {
    var body = $(e.target)
        .closest(".dataTables_wrapper")
        .find(".dataTables_scrollBody")
        .get(0);
    if (!body) return;
    requestAnimationFrame(function () {
        var top = body.scrollTop;
        body.scrollTop = top + 1;
        if (body.scrollTop === top) {
            body.scrollTop = top - 1;
        }
        body.style.paddingBottom = "1px";
        requestAnimationFrame(function () {
            body.style.paddingBottom = "";
            body.scrollTop = top;
        });
    });
});

window.initializeEdit = function () {
    var attributes = [
        "SILVER",
        "ALGINATE",
        "HEEL",
        "FOAM",
        "ANTIBACTERIAL",
        "CAVITY",
        "SACRUM",
        "ZINC",
        "WATERPROOF",
        "SENSITIVE",
        "FIBER",
        "NONBORDER",
        "BORDER",
        "HONEY",
        "NONSTERILE",
        "STERILE",
        "SILICONE",
        "SAP",
    ];

    var exampleModal = document.getElementById("exampleModal");
    exampleModal.addEventListener("show.bs.modal", (event) => {
        var button = event.relatedTarget;
        var sku = button.getAttribute("data-bs-sku");

        window.axios
            .get("/sku/" + sku)
            .then(function (response) {
                // handle success
                $("#materialText").text(
                    response.data.product["Material Description"],
                );
                $("#dropdownSegments").text(response.data.product.Segment);
                $("#clusterText").text(response.data.product.Cluster);
                $("#manufacturerText").text(
                    response.data.product["Manufacturer"],
                );
                $("#oManufacturerText").text(
                    response.data.product["Original Manufacturer"],
                );

                // Display active ingredient
                if (
                    response.data.product.active_ingredient &&
                    response.data.product.active_ingredient.active_ingredient
                ) {
                    $("#activeIngredientText").text(
                        response.data.product.active_ingredient
                            .active_ingredient,
                    );
                    $("#activeIngredientInput").val(
                        response.data.product.active_ingredient
                            .active_ingredient,
                    );
                } else {
                    $("#activeIngredientText").text("-");
                    $("#activeIngredientInput").val("");
                }

                // Reset to display mode
                $("#activeIngredientDisplay").show();
                $("#activeIngredientInput").hide();

                attributes.forEach(function (attribute) {
                    if (response.data.product[attribute] > 0) {
                        $(".attribute" + attribute)
                            .addClass("bg-primary")
                            .removeClass("bg-secondary");
                    } else {
                        $(".attribute" + attribute)
                            .removeClass("bg-primary")
                            .addClass("bg-secondary");
                    }
                });
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                const modalTitle = exampleModal.querySelector(".modal-title");
                const modalBodyInput =
                    exampleModal.querySelector(".modal-body input");
                modalTitle.textContent = `Edit SKU ${sku}`;
            });

        $(".segment").on("click", function (el) {
            segment = $(this).data("segment");
            window.axios
                .post("/sku/" + sku, {
                    segment,
                })
                .then(function (response) {
                    $("#clusterText").text(response.data.Cluster);
                    $("#dropdownSegments").text(response.data.Segment);
                })
                .catch(function (error) {
                    console.log(error);
                });
        });

        $(".attribute").on("click", function (el) {
            value = $(this).hasClass("bg-primary") ? 0 : 1;
            attribute = $(this).data("attribute");
            window.axios
                .post("/sku/" + sku, {
                    attribute,
                    value,
                })
                .then(function (response) {
                    if (value > 0) {
                        $(".attribute" + attribute)
                            .addClass("bg-primary")
                            .removeClass("bg-secondary");
                    } else {
                        $(".attribute" + attribute)
                            .removeClass("bg-primary")
                            .addClass("bg-secondary");
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        });

        // Handle click on active ingredient display to switch to edit mode
        $("#activeIngredientDisplay").on("click", function () {
            $(this).hide();
            $("#activeIngredientInput").show().focus();
        });

        // Handle blur (focus out) to save and switch back to display mode
        $("#activeIngredientInput").on("blur", function () {
            const activeIngredient = $(this).val();
            
            // Update display text
            $("#activeIngredientText").text(activeIngredient || "-");
            
            // Switch back to display mode
            $("#activeIngredientDisplay").show();
            $("#activeIngredientInput").hide();
            
            // Save the change
            window.axios
                .post("/sku/" + sku, {
                    active_ingredient: activeIngredient,
                })
                .then(function (response) {
                    console.log("Active ingredient saved");
                })
                .catch(function (error) {
                    console.log(error);
                    alert("Error saving active ingredient");
                });
        });

        // Handle Enter key in active ingredient input
        $("#activeIngredientInput").on("keypress", function (e) {
            if (e.which === 13) { // Enter key
                $(this).blur(); // Trigger blur to save
            }
        });

        // Handle save button click - save all changes including active ingredient
        $("#saveActiveIngredient").on("click", function () {
            const activeIngredient = $("#activeIngredientInput").val();
            
            // Save active ingredient
            window.axios
                .post("/sku/" + sku, {
                    active_ingredient: activeIngredient,
                })
                .then(function (response) {
                    // Close modal on success
                    $("#exampleModal").modal("hide");
                })
                .catch(function (error) {
                    console.log(error);
                    alert("Error saving changes");
                });
        });
    });
    
    // Handle Enter key press anywhere in the modal to trigger save
    $("#exampleModal").on("keypress", function (e) {
        if (e.which === 13 && !$(e.target).is('textarea')) { // Enter key, but not in textarea
            e.preventDefault();
            $("#saveActiveIngredient").click();
        }
    });
    
    $("#exampleModal").on("hide.bs.modal", function () {
        location.reload();
    });
};

window.initializeReferences = function (orderColumn) {
    $("#references").DataTable({
        language: {
            decimal: ",",
            thousands: ".",
        },
        order: [orderColumn, "desc"],
        pageLength: 100,
    });

    $("#additional").DataTable({
        language: {
            decimal: ",",
            thousands: ".",
        },
        order: [orderColumn, "desc"],
        pageLength: 1000,
    });

    var popoverTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="popover"]'),
    );
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl);
    });
};

function saveSimulation(id, value) {
    return $.ajax({
        type: "POST",
        url: "/simulation/save",
        data: { id, percent: value },
    });
}

function savePC(id, value) {
    return $.ajax({
        type: "POST",
        url: "/pc/save",
        data: { id, pc: value },
    });
}

function getDataAttr(element, name) {
    const value = $(element).attr(`data-${name}`);

    return typeof value === "string" ? value.trim() : "";
}

window.inlineEdit = function (e) {
    e.preventDefault();
    const elem = $(this);
    const id = getDataAttr(elem, "id");
    const nameAttr = elem.hasClass("sim-edit") ? "percent" : "pc";
    const input = $("<input>")
        .attr("type", "text")
        .attr("name", nameAttr)
        .attr("value", elem.text().trim());
    const classAttr = elem.hasClass("sim-edit")
        ? "text-end bg-sim"
        : "text-end";
    const replaceWith = $("<td>").attr("class", classAttr).append(input);
    elem.hide();
    elem.after(replaceWith);
    input.trigger("focus");

    const saveFunction = elem.hasClass("sim-edit") ? saveSimulation : savePC;

    input.on("blur", (e) => {
        e.preventDefault();
        saveFunction(id, input.val().trim().replace(",", "."))
            .done(() => window.location.reload())
            .fail(() => {
                replaceWith.remove();
                elem.show();
            });
        return false;
    });

    replaceWith.on("keydown", (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            saveFunction(id, input.val().trim().replace(",", "."))
                .done(() => window.location.reload())
                .fail(() => {
                    replaceWith.remove();
                    elem.show();
                });
            return false;
        }

        if (e.key === "Escape") {
            replaceWith.remove();
            elem.show();
            return false;
        }

        return true;
    });
};

function getLastIncrease(data) {
    // Dynamisch die Perioden basierend auf config('app.date.to') erstellen
    const appDateTo = window.appDateTo; // Das Datum aus der Blade-Vorlage
    const [year, month] = appDateTo.split("-").map(Number);

    const periods = [];
    for (let y = 2021; y <= year; y++) {
        for (let m = 1; m <= 12; m++) {
            if (y === year && m > month) break; // Stoppe, wenn wir das aktuelle Jahr und den aktuellen Monat überschreiten
            const period = `PREIS_${String(y).slice(-2)}${String(m).padStart(2, "0")}`;
            periods.push(period);
        }
    }

    // Suche nach der letzten Preiserhöhung
    let lastIncreaseDate = "";
    let lastIncreasePercent = 0;
    for (let i = periods.length - 1; i > 0; i--) {
        if (data[periods[i]] > data[periods[i - 1]]) {
            lastIncreaseDate = periods[i];
            lastIncreasePercent =
                (100 * (data[periods[i]] - data[periods[i - 1]])) /
                data[periods[i - 1]];
            break;
        }
    }

    // Rückgabe des letzten Erhöhungsdatums und Prozentsatzes
    return [
        lastIncreaseDate
            ? `${lastIncreaseDate.substring(6, 8)}-${lastIncreaseDate.substring(8, 10)}`
            : "",
        lastIncreasePercent,
    ];
}

$(document).ready(function () {
    initializeFilters();
    initializeSimulationToggle();

    if ($('#downloadGroup').length) {
        initializeDownloads();
    }

    $("#add_multiple").click(function (e) {
        e.preventDefault();
        var reference = getDataAttr(this, "reference");
        var checked = $('input[name="add_equivalence"]:checked');
        var pzn = [];
        $.each(checked, function () {
            pzn.push($(this).val());
        });
        if (pzn.length > 0) {
            window.axios
                .post("/references/add_multiple/" + reference, {
                    pzn,
                })
                .then(function (response) {
                    window.location.href = "/references/edit/" + reference;
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    });

    $("#remove_multiple").click(function (e) {
        e.preventDefault();
        var reference = getDataAttr(this, "reference");
        var checked = $('input[name="remove_equivalence"]:checked');
        var pzn = [];
        $.each(checked, function () {
            pzn.push($(this).val());
        });
        if (pzn.length > 0) {
            window.axios
                .post("/references/remove_multiple/" + reference, {
                    pzn,
                })
                .then(function (response) {
                    window.location.href = "/references/edit/" + reference;
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    });

    $("#report tbody").on("click", "td:not(.noclick)", function () {
        /* return if URL contains ref parameter */
        if (window.location.href.indexOf("ref") > -1) {
            return;
        }

        $(".parallel-expanded").remove();

        /* if row is already expanded, remove all rows below */
        if ($(this).parent().next().hasClass("expanded")) {
            $(".expanded").remove();
            return;
        }

        $(".expanded").remove();

        var pzn = getDataAttr($(this).parent(), "pzn");
        var row = $(this).parent();
        if (pzn == "") {
            return;
        }
        var url = "/references/get/" + encodeURIComponent(pzn);
        var appDateTo = window.appDateTo; // Dynamisches Datum aus der Blade-Vorlage
        var dynamicPriceField = `PREIS_${appDateTo.slice(2).replace("-", "")}`; // Erzeugt z. B. "PREIS_2309"

        $.ajax({
            url: url,
            type: "GET",
            success: function (data) {
                /* add table rows from json data */
                var html = "";

                /* sort data by product.PREIS_2309 / product.PC */
                data.sort(function (a, b) {
                    return (
                        parseFloat(a.product[dynamicPriceField]) /
                            parseInt(a.product["PC"]) -
                        parseFloat(b.product[dynamicPriceField]) /
                            parseInt(b.product["PC"])
                    );
                });

                $.each(data, function (index, value) {
                    if (value.product["PZN"] == pzn) {
                        return;
                    }
                    [lastIncreaseDate, lastIncreasePercent] = getLastIncrease(
                        value.product,
                    );
                    html += '<tr class="expanded">';
                    html +=
                        "<td>" +
                        value.product["Original Manufacturer"] +
                        "</td>";
                    html +=
                        "<td>" +
                        value.product["Material Description"] +
                        "</td>";
                    html += "<td>" + value.product["PZN"] + "</td>";
                    html += "<td></td>";
                    html +=
                        '<td class="text-end">' +
                        value.product["MAT_ST"] +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        value.product["MAT_VAL"] +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        Math.round(value.product["PC"]) +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        value.product[dynamicPriceField] +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        (
                            parseFloat(value.product[dynamicPriceField]) /
                            parseInt(value.product["PC"])
                        )
                            .toFixed(2)
                            .toLocaleString("de-DE") +
                        "</td>";
                    html +=
                        '<td class="text-end">' + lastIncreaseDate + "</td>";
                    html +=
                        '<td class="text-end">' +
                        lastIncreasePercent.toFixed(1).toLocaleString("de-DE") +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        (value.price
                            ? (
                                  parseFloat(value.price["price"]) /
                                  parseInt(value.product["PC"])
                              )
                                  .toFixed(2)
                                  .toLocaleString("de-DE")
                            : "") +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        (value.price ? value.price["date"] : "") +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        (value.price & value.price.old
                            ? (
                                  (100 *
                                      (parseFloat(value.price["price"]) -
                                          parseFloat(value.price["old"]))) /
                                  parseFloat(value.price["old"])
                              )
                                  .toFixed(1)
                                  .toLocaleString("de-DE")
                            : "") +
                        "</td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "</tr>";
                });
                row.after(html);
            },
        });
    });

    $("#report tbody").on("click", ".load-parallel", function () {
        var button = $(this); // Der Button, der geklickt wurde
        var row = button.closest("tr"); // Die zugehörige Zeile
        var pzn = getDataAttr(row, "pzn");

        /* return if URL contains ref parameter */
        if (window.location.href.indexOf("ref") > -1) {
            return;
        }

        $(".expanded").remove();

        if (row.next().hasClass("parallel-expanded")) {
            // Entferne die parallelen Zeilen
            row.nextUntil(":not(.parallel-expanded)").remove();
            return; // Beende die Funktion
        }

        $(".parallel-expanded").remove();

        if (!pzn) {
            return;
        }

        var url = "/pzn-mapping/get/" + encodeURIComponent(pzn); // API-Endpunkt, um parallele Produkte zu laden
        var appDateTo = window.appDateTo; // Dynamisches Datum aus der Blade-Vorlage
        var dynamicPriceField = `PREIS_${appDateTo.slice(2).replace("-", "")}`; // Erzeugt z. B. "PREIS_2309"

        $.ajax({
            url: url,
            type: "GET",
            success: function (data) {
                var html = "";
                // Iteriere über die parallelen Produkte und füge sie als neue Zeilen hinzu
                $.each(data, function (index, value) {
                    console.log(dynamicPriceField);

                    if (value.piv_pzn == pzn) {
                        return;
                    }
                    if (!value.product) {
                        console.warn("Produktdaten fehlen:", value);
                        return;
                    }

                    [lastIncreaseDate, lastIncreasePercent] = getLastIncrease(
                        value.product,
                    );
                    html += '<tr class="parallel-expanded">';
                    Object.keys(window.dynamicColumns).forEach(function (key) {
                        var columnIndex = window.dynamicColumns[key]; // Hole den Spaltenindex
                        var columnKey = window.columnMappings[columnIndex]; // Hole den Spaltennamen
                        html +=
                            "<td>" + (value.product[columnKey] || "") + "</td>";
                    });
                    html += "<td></td>";
                    html +=
                        '<td class="text-end">' +
                        value.product.MAT_ST +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        value.product.MAT_VAL +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        Math.round(value.product.PC) +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        value.product[dynamicPriceField] +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        (
                            parseFloat(value.product[dynamicPriceField]) /
                            parseInt(value.product["PC"])
                        )
                            .toFixed(2)
                            .toLocaleString("de-DE") +
                        "</td>";
                    html +=
                        '<td class="text-end">' + lastIncreaseDate + "</td>";
                    html +=
                        '<td class="text-end">' +
                        lastIncreasePercent.toFixed(1).toLocaleString("de-DE") +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        (value.price?.price && value.product.PC
                            ? (
                                  parseFloat(value.price["price"]) /
                                  parseInt(value.product["PC"])
                              )
                                  .toFixed(2)
                                  .toLocaleString("de-DE")
                            : "") +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        (value.price?.date ?? "") +
                        "</td>";
                    html +=
                        '<td class="text-end">' +
                        (value.price?.old && value.price?.price
                            ? (
                                  (100 *
                                      (parseFloat(value.price["price"]) -
                                          parseFloat(value.price["old"]))) /
                                  parseFloat(value.price["old"])
                              )
                                  .toFixed(1)
                                  .toLocaleString("de-DE")
                            : "") +
                        "</td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "</tr>";
                });

                row.after(html);
            },
            error: function (error) {
                console.error("Error loading parallel products:", error);
            },
        });
    });
});

initializeFilters = function () {
    $(".filterOptions").on("input", function (e) {
        var filter = $(this).val().toLowerCase();
        $(this)
            .parent()
            .find(".dropdown-item")
            .each(function () {
                if ($(this).text().toLowerCase().includes(filter)) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
    });
};

window.initializeSimulationToggle = function() {
    // Get saved visibility states from localStorage with defaults
    const visibilityStates = {
        pricing: localStorage.getItem('simulationVisibility_pricing') || 'show',
        equivalences: localStorage.getItem('simulationVisibility_equivalences') || 'hide',
        nomenclature: localStorage.getItem('simulationVisibility_nomenclature') || 'hide',
        piv: localStorage.getItem('simulationVisibility_piv') || 'hide',
        simulation: localStorage.getItem('simulationVisibility_simulation') || 'show'
    };

    // Determine current page
    let currentPage = 'pricing';
    const pathname = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    
    if (pathname.includes('references')) {
        currentPage = 'equivalences';
    } else if (pathname.includes('nomenclature')) {
        currentPage = 'nomenclature';
    } else if (pathname.includes('piv')) {
        currentPage = 'piv';
    } else if (urlParams.get('ref')) {
        currentPage = 'simulation';
    }

    // Get current visibility state
    const currentVisibility = visibilityStates[currentPage];
    
    // Update toggle button text
    $('#simulationStatus').text(currentVisibility);
    
    // Apply visibility to simulation columns and 3M average text
    applySimulationVisibility(currentVisibility);
    
    // Handle toggle dropdown click
    $('.simulation-toggle-option').on('click', function(e) {
        e.preventDefault();
        const newVisibility = $(this).data('value');
        
        // Save to localStorage for current page
        localStorage.setItem('simulationVisibility_' + currentPage, newVisibility);
        
        // Update button text
        $('#simulationStatus').text(newVisibility);
        
        // Apply visibility
        applySimulationVisibility(newVisibility);
    });
};

function applySimulationVisibility(visibility) {
    if (visibility === 'show') {
        // Show simulation columns
        $('.bg-sim').show();
        $('th:contains("Sim")').show();
        $('th:contains("&Delta; Sim")').show();

        // Show 3M average text
        $('.col.text-end.pe-3').show();
    } else {
        // Hide simulation columns
        $('.bg-sim').hide();
        $('th:contains("Sim")').hide();
        $('th:contains("&Delta; Sim")').hide();

        // Hide 3M average text
        $('.col.text-end.pe-3').hide();
    }
}

// --- Cached Downloads ---

window.initializeDownloads = function () {
    var pollTimer = null;

    function setButtonState(type, status) {
        var btn = $('#download-' + type);
        if (status === 'ready') {
            btn.removeClass('disabled').removeAttr('aria-disabled').css('pointer-events', '');
            btn.find('i').attr('class', 'bi bi-download');
        } else if (status === 'generating') {
            btn.removeAttr('aria-disabled').removeClass('disabled').css('pointer-events', 'none');
            btn.find('i').attr('class', 'spinner-border spinner-border-sm');
        } else {
            btn.addClass('disabled').attr('aria-disabled', 'true').css('pointer-events', '');
            btn.find('i').attr('class', 'bi bi-download');
        }
    }

    function checkStatus() {
        window.axios.get('/reports/status')
            .then(function (response) {
                var data = response.data;
                var anyGenerating = false;
                $.each(data, function (type, info) {
                    setButtonState(type, info.status);
                    if (info.status === 'generating') {
                        anyGenerating = true;
                    }
                });

                if (!anyGenerating) {
                    stopPolling();
                    $('#updateDownloads').prop('disabled', false);
                    $('#updateDownloads i').removeClass('spin-animation');
                }
            })
            .catch(function () {});
    }

    function startPolling() {
        if (pollTimer) return;
        pollTimer = setInterval(checkStatus, 2000);
    }

    function stopPolling() {
        if (pollTimer) {
            clearInterval(pollTimer);
            pollTimer = null;
        }
    }

    // Initial status check
    checkStatus();

    // "Update Downloads" button
    $('#updateDownloads').on('click', function () {
        $(this).prop('disabled', true);
        $(this).find('i').addClass('spin-animation');

        // Disable all download buttons and show spinners
        $('.download-btn').each(function () {
            setButtonState($(this).data('type'), 'generating');
        });

        window.axios.post('/reports/generate')
            .then(function () {
                startPolling();
            })
            .catch(function () {
                $('#updateDownloads').prop('disabled', false);
                $('#updateDownloads i').removeClass('spin-animation');
                checkStatus();
            });
    });
};
